export var now = function () {
    return Date.now ? Date.now() : +new Date();
};



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/moment/now.js
// module id = 325
// module chunks = 0